<form [formGroup]="tatForm" (ngSubmit)="isFormSubmitted = true;onSaveClick()">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Additional TAT</h4>
        <button type="button" class="btn-close" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="card1">
                    <div class="card-body1">
                        <div class="row">
                            <div class="col-md-8">
                                <label for="days" class="form-label">Transit Time </label>
                                <div class="input-group mb-2">
                                    <span class="input-group-text group-label-sm">Days</span>
                                    <input type="number" class="form-control form-control-sm"
                                        formControlName="txtDays">
                                    <span class="input-group-text group-label-sm">Hours</span>
                                    <input type="number" class="form-control form-control-sm"
                                        formControlName="txtHours">
                                        <span class="input-group-text group-label-sm">Minutes</span>
                                        <input type="number" class="form-control form-control-sm"
                                            formControlName="txtMinutes">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-2">
                                    <label for="remark" class="form-label">Remark <span class="mandatory">*</span></label>
                                    <input type="text" id="remark" class="form-control form-control-sm"
                                        formControlName="txtRemark"
                                        [ngClass]="{'is-invalid':(isFormSubmitted ||tatForm.get('txtRemark').touched) &&tatForm.get('txtRemark').errors}" />
                                    <div *ngIf="(isFormSubmitted || tatForm.get('txtRemark').touched) &&tatForm.get('txtRemark').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="tatForm.get('txtRemark').errors.required">Remark is
                                            Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-12 grid-container">
                                <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                                    [rowData]="AWBTATList" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                                    [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [suppressMenuHide]="true"
                                    [pagination]="true" (gridReady)="onGridReady($event)">
                                </ag-grid-angular>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="resetFrom();">Reset</button>
        <button type="submit" class="btn btn-outline-dark">Save</button>
    </div>
</form>